import { Alert } from '@fidalia/ui';
import { createFileRoute } from '@tanstack/react-router';

import { ExplicationForfait } from '@/features/file-attente/forfait';
import { useQuotaAtteint } from '@/features/app/use-quota';
import { AdresseEnvoi } from '@/features/reglages/emails-panel';

export const Route = createFileRoute('/_app/settings/sending')({
  component: SendingSettings,
});

/** L'adresse d'expédition, avec l'explication complète quand le quota d'envoi est atteint. */
function SendingSettings() {
  const { atteint, forfait } = useQuotaAtteint();

  return (
    <AdresseEnvoi
      alerte={
        atteint ? (
          <Alert tone="danger" title="Quota d’envoi par défaut atteint">
            <ExplicationForfait forfait={forfait} />
          </Alert>
        ) : null
      }
    />
  );
}
